import {
  AgentsPage,
  AgentPage,
  NewAgentPage,
  AgentsBillingPage,
  ConversationsPage,
  ConversationsBillingPage,
  ConversationBillingDetailsPage,
} from '../../pages';
import ConversationPage from '../../pages/conversation';
import { createOrgScopedRoute } from './OrgScopedRouteGuard';

export const AgentsOrgScopedRoute = createOrgScopedRoute(AgentsPage);

export const ConversationsOrgScopedRoute = createOrgScopedRoute(ConversationsPage);

export const AgentsBillingOrgScopedRoute = createOrgScopedRoute(AgentsBillingPage);

export const NewAgentOrgScopedRoute = createOrgScopedRoute(NewAgentPage);

export const AgentOrgScopedRoute = createOrgScopedRoute(AgentPage);

export const ConversationDetailOrgScopedRoute = createOrgScopedRoute(
  ConversationPage,
  { pageProps: { agentId: '', conversationId: '' } }
);

export const ConversationsBillingOrgScopedRoute =
  createOrgScopedRoute(ConversationsBillingPage);

export const ConversationBillingDetailOrgScopedRoute = createOrgScopedRoute(
  ConversationBillingDetailsPage
);
